var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPageShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#4D5451"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9 22.3915C46.3333 22.1082 45.7667 22.2499 45.3417 22.6749L44.0667 23.9499C42.0833 25.3665 39.3917 25.3665 37.4083 23.9499L36.1333 22.6749C35.5667 22.1082 34.7167 22.1082 34.15 22.6749L32.875 23.9499C30.8917 25.3665 28.2 25.3665 26.2167 23.9499L24.6583 22.6749C24.2333 22.2499 23.6667 22.1082 23.1 22.3915C22.5333 22.6749 22.25 23.0999 22.25 23.6665V36.6999C22.25 40.5249 24.2333 44.0665 27.4917 46.1915L34.2917 50.4415C34.575 50.5832 34.7167 50.7249 35 50.7249C35.2833 50.7249 35.5667 50.5832 35.7083 50.4415L42.5083 46.1915C45.7667 44.0665 47.75 40.5249 47.75 36.6999V23.6665C47.75 23.0999 47.4667 22.5332 46.9 22.3915ZM25.0833 36.6999V26.7832C27.6333 28.3415 31.0333 28.1999 33.5833 26.7832V46.6165L29.05 43.7832C26.5 42.2249 25.0833 39.5332 25.0833 36.6999ZM44.9167 36.6999C44.9167 39.5332 43.5 42.2249 40.95 43.7832L36.4167 46.6165V26.7832C38.9667 28.1999 42.3667 28.3415 44.9167 26.7832V36.6999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPageShield);
export default __webpack_public_path__ + "static/media/team-page-shield.fcb3dc34f68c62541492572b63b6b172.svg";
export { ForwardRef as ReactComponent };